import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage, useIntl} from "react-intl";

import {
    Box,
    Table,
    TableBody,
    TableHead,
} from "@mui/material";

import {greyishBlue500} from "assets/jss/main";

import RetailerRow from "./RetailerRow";
import TopTableHeader from "../../TopTablesComponents/TopTableHeader";
import TopTableLoader from "../../TopTablesComponents/TopTableLoader";
import RankHeaderLabel from "../../TopTablesComponents/RankHeaderLabel";

function TopRetailersTable({ data, loading, currency }) {
    const intl = useIntl();

    if (loading) {
        return <TopTableLoader />;
    }

    if (!data?.ranking?.length) {
        return (
            <div style={{ color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center" }}>
                <FormattedMessage id="dashboard.retailersRanking.table.no_result" />
            </div>
        );
    }

    const headers = [
        { label: <RankHeaderLabel>{intl.formatMessage({ id: "dashboard.retailersRanking.table.header.name" })}</RankHeaderLabel>, align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.sales" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.topProducts" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.potentialRevenue" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.actualRevenue" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.returnRevenue" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.canceledRevenue" }), align: "left" },
        { label: intl.formatMessage({ id: "dashboard.retailersRanking.table.header.clientCancellation" }), align: "left" },
    ];

    return (
        <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 800 }}>
                <TableHead>
                    <TopTableHeader headers={headers} />
                </TableHead>
                <TableBody>
                    {data.ranking.map((retailer, index) => (
                        <RetailerRow
                            key={retailer.name ?? index}
                            rank={index + 1}
                            retailer={retailer}
                            currency={currency}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

TopRetailersTable.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
};

export default TopRetailersTable;
